import axios from '../axios';
import util from './util';
const apiPath = 'api/admin/admins';

const adminApi = {
    me: () => {
        return axios.get(`${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/me`);
    },
    invite: entity => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/invite`,
            {
                ...entity
            }
        );
    },
    index: query => {
        return axios.get(
            `${
                process.env.VUE_APP_API_ENDPOINT
            }/${apiPath}/index?${util.queryToString(query)}`
        );
    },
    show: id => {
        return axios.get(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/show/${id}`
        );
    },
    update: (id, entity) => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/update/${id}`,
            {
                ...entity
            }
        );
    },
    delete: id => {
        return axios.delete(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/delete/${id}`
        );
    },

    // creds
    resentInvitation: id => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/${id}/resend_invitation`
        );
    },
    activation: activationHash => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/${activationHash}/activate`
        );
    },
    requestResetPassword: entity => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/request_reset_password`,
            {
                ...entity
            }
        );
    },
    resetPassword: entity => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/reset_password`,
            {
                ...entity
            }
        );
    },
    forceResetPassword: (id, entity) => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/${id}/force_reset_password`,
            {
                ...entity
            }
        );
    },

    //roles
    roleIndex: query => {
        return axios.get(
            `${
                process.env.VUE_APP_API_ENDPOINT
            }/${apiPath}/roles/index?${util.queryToString(query)}`
        );
    },
    resourceIndex: query => {
        return axios.get(
            `${
                process.env.VUE_APP_API_ENDPOINT
            }/${apiPath}/resources/index?${util.queryToString(query)}`
        );
    },
    rolePermissionIndex: (roleId, query) => {
        return axios.get(
            `${
                process.env.VUE_APP_API_ENDPOINT
            }/${apiPath}/roles/${roleId}/permissions/index?${util.queryToString(
                query
            )}`
        );
    }
};

export default adminApi;
